var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"d":"M13.0615 7L9.06152 3","stroke":"#4768EB","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.56152 14.5L0.561523 15.5L1.56152 10.5L11.5615 0.5L15.5615 4.5L5.56152 14.5Z","stroke":"#4768EB","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0.0615234)"})))]);
}

Edit.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
